export default "__VITE_ASSET__90ff12a6__"